<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add SLA</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="vendorSelected"
              (change)="onVendorChange($event.target.selectedIndex)">
        <option *ngFor="let vendor of vendors" [value]="vendor.id">{{vendor.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected"
              (change)="onGroupChange($event.target.selectedIndex)">
        <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="prioritySelected"
              (change)="onPriorityChange($event.target.selectedIndex)">
        <option *ngFor="let priority of priorities" [value]="priority.id">{{priority.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="name"
               placeholder="Enter name">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="desc"
               placeholder="Enter Description">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input class="form-control radius-0 font-13"
               placeholder="Response Time in Minute" [(ngModel)]="respTime">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input class="form-control radius-0 font-13"
               placeholder="Resolution Time in Minute" [(ngModel)]="resoTime">
      </div>
    </div>
    <!--<div class="form-group">-->
      <!--<div class="form-group">-->
        <!--<input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1"-->
               <!--placeholder="Response Time" [(ngModel)]="respTime">-->
        <!--<owl-date-time [pickerType]="'timer'" #dt1></owl-date-time>-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="form-group">-->
      <!--<div class="form-group">-->
        <!--<input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2"-->
               <!--placeholder="Resolution Time" [(ngModel)]="resoTime">-->
        <!--<owl-date-time [pickerType]="'timer'" #dt2></owl-date-time>-->
      <!--</div>-->
    <!--</div>-->
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>

